module.exports = __webpack_public_path__ + "static/media/events_03.36853490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/JPEG/events_03.jpg
// module id = 5921
// module chunks = 0